<template>
  <div v-if="resDetails.serviceLocation" class="service-info" :class="{ '__review': props.showBarcode }">
    <div class="details" :class="{ '__column': props.showBarcode }">
      <div class="item">
        <img class="app-icon" src="@ridmv/web-themes/images/icons/clipboard-list-solid.svg" alt="">
        <div>
          <div>Service(s)</div>
          <div class="desc">{{ resDetails.serviceType }}</div>
        </div>
      </div>

      <div class="item">
        <img class="app-icon" src="@ridmv/web-themes/images/icons/map-marked-alt-solid.svg" alt="">
        <div>
          <div>Location</div>
          <div class="desc">
            <div>{{ resDetails.serviceLocation.location }}</div>
            <div v-if="resAppointmentLocation && resAppointmentLocation.addressLine1">
              <div>{{ resAppointmentLocation.addressLine1 }}</div>
              <div v-if="resAppointmentLocation.addressLine2">{{ resAppointmentLocation.addressLine2 }}</div>
              <div class="dummy"  style="min-height: fit-content">
                {{ resAppointmentLocation.city }}, {{ resAppointmentLocation.state }}
                {{ resAppointmentLocation.zip }}<span v-if="resAppointmentLocation.zipPlus">-{{ resAppointmentLocation.zipPlus }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="item">
        <img class="app-icon" src="@ridmv/web-themes/images/icons/calendar-solid.svg" alt="">
        <div>
          <div>Date and time</div>
          <div class="desc">
            <div>
              {{ formatWeekday(resDetails.serviceDate) }},
              <span class="app-nowrap">{{ formatMonthDayYear(resDetails.serviceDate) }}</span>
            </div>
            <div>{{ resDetails.serviceTime }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="barcode" v-if="props.showBarcode && resAppointmentBarcode.length > 0">
      <span class="code">
        <img :src="`data:image/png;base64,${resAppointmentBarcode}`" alt="Confirmation barcode">
      </span>
      <div class="item" >
        <img class="app-icon" src="@ridmv/web-themes/images/icons/check-square-solid.svg" alt="">
        <div>
          <div class="app-nowrap">Confirmation number</div>
          <div class="desc">{{ resAppointmentNum }}</div>
        </div>
      </div>
    </div>
  </div>
</template>


<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import {formatWeekday, formatMonthDayYear} from '../../../utils/globalFilters'

// Vuex store
const store = useStore();

// Props
const props = defineProps({
  showBarcode: {
    type: Boolean,
    required: false,
    default: false,
  },
});

// Computed properties 
const resDetails = computed(() => store.state.user.resDetails);
const resAppointmentNum = computed(() => store.state.user.resAppointmentNum);
const resAppointmentBarcode = computed(() => store.state.user.resAppointmentBarcode);
const resAppointmentLocation = computed(() => store.state.user.resAppointmentLocation);
</script>



<style scoped lang="scss">
.service-info {
  // TODO: BEGIN replace w/ %info-detail from web-themes v1.1.1
  background-color: var(--ri-darker-blue);
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  flex-wrap: wrap;
  color: white;
  padding: 2em 1em 0 2em;
  margin-bottom: calc(var(--padding-vertical) * 2);
  // TODO: END replace
  width: clamp(50vw, 60vw, 70vw);

  &.__review {
    display: flex;
    max-width: 55vw;
    @media only screen and (max-width: 1200px) {
      max-width: unset;
    }
  }
  .details {  // services/location/date+time
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    &.__column {
      flex-direction: column;
      max-width: 65%;
      width: unset;
      .item {
        padding-right: clamp(2em, 3vw, 5vw);
        &:first-child {
          max-width: unset;
        }
      }
      @media only screen and (max-width: 1200px) {
        max-width: 95%;
      }
    }
  }
  .barcode {
    .code {
      background-color: white;
      display: inline-block;
      padding: 1em 0 0.05em 0.35em;
      margin-bottom: 1em;
    }
  }
  .item {   // icon + text
    display: flex;
    flex-wrap: nowrap;
    > div { // text only
      padding: 0 2em 2em 0.75em;
    }
  }
  .desc {
    @extend %font-sans-bold;
    font-size: 1.25rem;
    line-height: 1.5em;
    padding-top: 0.25em;
  }

  @media only screen and (max-width: 800px) {
    max-width: unset;
    width: 100%;
  }
  @media print {
    @page { size: 11in 8.5in; }
    background-color: var(--print-background);
    color: var(--print-font-color);
    font-size: 1rem;
    padding: 1em 0;
    max-width: unset;
    min-width: 700px;
    .app-icon {
      filter: invert(0%) sepia(0%) saturate(7500%) hue-rotate(143deg) brightness(108%) contrast(106%);
    }
    .details {
      font-size: 1rem;
      &.__column {
        max-width: 65%;
      }
    }
    .item > div {
      padding-bottom: 1em;
    }
    .desc {
      font-size: 1rem;
    }
  }
}
</style>
